import { useRef, useEffect } from 'react';
import { useThree, useFrame } from '@react-three/fiber';
import * as THREE from 'three';

interface CameraControllerProps {
  target: [number, number, number] | null;
  isZoomed: boolean;
}

export default function CameraController({ target, isZoomed }: CameraControllerProps) {
  const { camera } = useThree();
  const targetPos = useRef(new THREE.Vector3(0, 0, 8));
  const lookTarget = useRef(new THREE.Vector3(0, 0, 0));
  const currentPos = useRef(new THREE.Vector3(0, 0, 8));
  const currentLook = useRef(new THREE.Vector3(0, 0, 0));

  useEffect(() => {
    if (isZoomed && target) {
      const dir = new THREE.Vector3(...target).normalize();
      targetPos.current.copy(dir.multiplyScalar(4.5));
      lookTarget.current.set(...target);
    } else {
      targetPos.current.set(0, 0.5, 8);
      lookTarget.current.set(0, 0, 0);
    }
  }, [target, isZoomed]);

  useFrame((_, delta) => {
    const speed = 2.5;
    currentPos.current.lerp(targetPos.current, delta * speed);
    currentLook.current.lerp(lookTarget.current, delta * speed);

    camera.position.copy(currentPos.current);
    camera.lookAt(currentLook.current);
  });

  return null;
}
